<template>
  <div class="addNewClass">
    <div class="content">
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>优惠券名称</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="">
            <el-row style="margin:0">
              <el-col :span="14">
                <div class="flex">
                  <el-input
                    v-model="form.title"
                    placeholder="请输入内容"
                    size="small"
                    class="newRidio160 marginR"
                  ></el-input>
                  <div class="color">
                    建议填写“10元代金券”、“买电脑送鼠标”等易于理解的具体优惠内容，限20个字以内
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>副标题</span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="">
            <el-row style="margin:0">
              <el-col :span="10">
                <div class="flex">
                  <el-input
                    v-model="form.sub_title"
                    size="small"
                    class="newRidio160"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row> -->
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>商品分类</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="">
            <el-row style="margin:0">
              <el-col :span="19">
                <el-radio-group
                  v-model="form.type"
                  @change="chengeticket"
                  style=" height: 41px;"
                >
                  <el-radio :label="1" :disabled="details_disabled"
                    >满减券</el-radio
                  >
                  <el-radio :label="2" :disabled="details_disabled"
                    >折扣券</el-radio
                  >
                  <el-radio :label="3" :disabled="details_disabled"
                    >代金券</el-radio
                  >
                  <el-radio :label="4" :disabled="details_disabled"
                    >兑换券</el-radio
                  >
                  <!-- <el-radio :label="5" :disabled="details_disabled"
                    >储值券</el-radio
                  >
                  <el-radio :label="6" :disabled="details_disabled"
                    >通用券</el-radio
                  >
                  <el-radio :label="7" :disabled="details_disabled"
                    >次数券</el-radio
                  > -->
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin:0" :span="19">
              <!-- 兑换券 -->
              <div class="box" v-if="ticketId == 4">
                <div class="flex" style="margin-bottom: 20px;">
                  <div class="fixedTitle marginT">类型:</div>
                  <div>
                    <el-radio-group v-model="conversion">
                      <div class="marginT">
                        <el-radio label="1">直接兑换</el-radio>
                      </div>
                      <!-- <div class="marginT">
                        <el-radio label="2"
                          >消费满<input
                            type="number"
                            class="radioInput"
                            v-model="form.change_cost"
                            :min="0"
                          />元</el-radio
                        >
                      </div> -->
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <!-- 储值券 -->
              <div class="box" v-if="ticketId == 5">
                <div class="flex marginT">
                  <div class="fixedTitle paddingT6">储值金额:</div>
                  <div>
                    面值<input
                      class="radioInput"
                      type="number"
                      v-model="form.chu_face_value"
                      :min="0"
                    />元
                  </div>
                </div>
              </div>
              <!-- 通用券 -->
              <div class="box" v-if="ticketId == 6">
                <div class="flex marginT">
                  <div class="fixedTitle">使用条件:</div>
                  <div style="height:58px;">
                    <textarea
                      name=""
                      id=""
                      style="height:100%;"
                      v-model="form.t_term"
                    ></textarea>
                  </div>
                </div>
              </div>
              <!-- 次数券 -->
              <div class="box" v-if="ticketId == 7">
                <div class="flex marginT">
                  <div class="fixedTitle">使用次数:</div>
                  <div style="height:28px;">
                    面值<input
                      class="radioInput"
                      type="number"
                      :min="0"
                      v-model="form.c_num"
                    />次
                  </div>
                </div>
              </div>
              <!-- 条件 -->
              <div class="box">
                <!-- 使用门槛 -->
                <div
                  class="flex marginT"
                  v-if="ticketId == 1 || ticketId == 2 || ticketId == 3"
                >
                  <div class="fixedTitle">使用门槛:</div>
                  <div>
                    <el-radio-group v-model="form.condition_type">
                      <div class="">
                        <el-radio label="0" :disabled="details_disabled"
                          >无使用门槛</el-radio
                        >
                      </div>
                      <div class="marginT">
                        <el-radio label="1" :disabled="details_disabled">
                          订单金额满
                          <input
                            type="number"
                            class="radioInput"
                            v-model="form.m_enough_money"
                            :min="0"
                            @blur="
                              form.m_enough_money = Number(
                                form.m_enough_money
                              ).toFixed(2)
                            "
                            :disabled="details_disabled"
                          />元
                        </el-radio>
                      </div>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 区别优惠内容 -->
                <!-- 满减券 -->
                <div class="flex marginT" v-if="ticketId == 1">
                  <div class="fixedTitle paddingT6">优惠内容:</div>
                  <div>
                    <el-radio-group v-model="form.free_type">
                      <div class="">
                        <el-radio label="0" :disabled="details_disabled">
                          固定金额
                          <input
                            type="number"
                            class="radioInput"
                            v-model="form.m_dec_money"
                            :min="0"
                            :disabled="details_disabled"
                            @blur="
                              form.m_dec_money = Number(
                                form.m_dec_money
                              ).toFixed(2)
                            "
                          />
                          元
                        </el-radio>
                      </div>
                      <div class="marginT">
                        <el-radio label="1" :disabled="details_disabled">
                          随机金额，范围内随机
                          <input
                            type="number"
                            class="radioInput"
                            v-model="form.m_rand_low"
                            :min="0"
                            :disabled="details_disabled"
                            @blur="
                              form.m_rand_low = Number(form.m_rand_low).toFixed(
                                2
                              )
                            "
                          />至
                          <input
                            type="number"
                            class="radioInput"
                            v-model="form.m_rand_high"
                            :min="0"
                            :disabled="details_disabled"
                            @blur="
                              form.m_rand_high = Number(
                                form.m_rand_high
                              ).toFixed(2)
                            "
                          />
                        </el-radio>
                      </div>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 折扣券 -->
                <div class="flex marginT" v-if="ticketId == 2">
                  <div class="fixedTitle paddingT6">优惠内容:</div>
                  <div>
                    <div>
                      打
                      <input
                        class="radioInput"
                        type="number"
                        v-model="form.zhe_discount"
                        @blur="form.zhe_discount = Number(form.zhe_discount)"
                        :min="0"
                        :max="10"
                        :disabled="details_disabled"
                      />
                      折
                    </div>
                    <div class="marginT">
                      <el-checkbox
                        v-model="zheStatus"
                        :disabled="details_disabled"
                        >最多优惠<input
                          class="radioInput"
                          v-model="form.zhe_limit_money"
                          :min="0"
                          @blur="
                            form.zhe_limit_money = Number(
                              form.zhe_limit_money
                            ).toFixed(2)
                          "
                          :disabled="details_disabled"
                        />元</el-checkbox
                      >
                    </div>
                  </div>
                </div>
                <!-- 代金券 -->
                <div class="flex marginT" v-if="ticketId == 3">
                  <div class="fixedTitle paddingT6">
                    优惠内容:
                  </div>
                  <div>
                    <el-radio-group>
                      <div class="">
                        <el-radio checked>
                          固定金额
                          <input
                            type="number"
                            class="radioInput"
                            v-model="form.d_face_value"
                            :min="0"
                            :disabled="details_disabled"
                            @blur="
                              form.d_face_value = Number(
                                form.d_face_value
                              ).toFixed(2)
                            "
                          />
                          元
                        </el-radio>
                      </div>
                    </el-radio-group>
                  </div>
                </div>
                <div class="flex marginT" v-if="ticketId != 4">
                  <div class="fixedTitle">可用商品:</div>
                  <div style="height:28px;">
                    <el-radio-group
                      v-model="form.change_goods_status"
                      @change="changeProductStatus(0)"
                    >
                      <el-radio label="0">全部商品</el-radio>
                      <el-radio label="1">部分商品</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="flex marginT" v-if="mallStatus && ticketId != 4">
                  <div class="fixedTitle"></div>
                  <!-- 封裝組件 -->
                  <multipleChoice
                    @checkedGoods="checkedGoods($event, 0)"
                    :jude="0"
                    :editDatas="checkedMalls"
                  ></multipleChoice>
                </div>
                <div class="flex marginT" v-if="ticketId == 4">
                  <div class="fixedTitle">可用商品:</div>
                  <div style="height:28px;">
                    <el-radio-group
                      v-model="form.credit_goods_status"
                      @change="changeProductStatus(1)"
                    >
                      <el-radio label="0">全部积分商品</el-radio>
                      <el-radio label="1">部分积分商品</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="flex marginT" v-if="integralStatus">
                  <div class="fixedTitle"></div>
                  <div style="height:auto;">
                    <multipleChoice
                      @checkedGoods="checkedGoods($event, 1)"
                      :jude="1"
                      :editDatas="checkedIntegral"
                    ></multipleChoice>
                  </div>
                </div>
                <div class="flex marginT">
                  <div class="fixedTitle">可用油品:</div>
                  <div style="height:28px;">
                    <el-radio-group
                      v-model="form.oli_goods_status"
                      @change="changeProductStatus(3)"
                    >
                      <el-radio label="0">全部油品</el-radio>
                      <el-radio label="1">部分油品</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="flex marginT" v-if="oilStatus">
                  <div class="fixedTitle"></div>
                  <!-- 封裝組件 -->
                  <multipleChoice
                    @checkedGoods="checkedGoods($event, 3)"
                    :jude="3"
                    :editDatas="checkedOils"
                  ></multipleChoice>
                </div>
                <div class="flex marginT" v-if="ticketId == 4">
                  <div class="fixedTitle">可用服务:</div>
                  <div style="height:28px;">
                    <el-radio-group v-model="form.service_goods_status">
                      <el-radio label="0">全部服务</el-radio>
                      <el-radio label="1">部分服务</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div
                  class="flex marginT"
                  v-if="form.service_goods_status == '1'"
                >
                  <div class="fixedTitle"></div>
                  <multipleChoice
                    @checkedGoods="checkedGoods($event, 4)"
                    :jude="4"
                    :editDatas="checkedServe"
                  ></multipleChoice>
                </div>
                <!-- <div class="flex marginT" v-if="ticketId == 4">
                  <div class="fixedTitle">核销方式:</div>
                  <div style="height:28px;">
                    <el-radio-group v-model="form.cancle_type">
                      <el-radio label="0">用户自助核销</el-radio>
                      <el-radio label="1">店员扫码核销</el-radio>
                    </el-radio-group>
                  </div>
                </div> -->
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>可领取时间</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-date-picker
            :disabled="details_disabled"
            size="mini"
            v-model="getTime"
            type="daterange"
            value-format="yyyy-M-d"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name marginT6">
            <span>有效期</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio
              v-model="form.is_term"
              label="0"
              :disabled="details_disabled"
            >
              <span class="paddingRight8">固定时间</span>
              <el-date-picker
                class="marginRL"
                size="mini"
                v-model="fixedTime"
                value-format="yyyy-M-d"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :disabled="details_disabled"
              >
              </el-date-picker>
            </el-radio>
          </div>
          <div class="marginT">
            <el-radio
              v-model="form.is_term"
              label="1"
              :disabled="details_disabled"
              >领取立即生效， <span>有效期:</span
              ><input
                type="number"
                :min="0"
                class="radioInput"
                v-model="form.term_end_day"
                :disabled="details_disabled"
                @blur="form.term_end_day = Number(form.term_end_day).toFixed(0)"
              />天
            </el-radio>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>可领取用户</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio v-model="form.user_limit" label="0">
              所有用户
            </el-radio>
          </div>
          <div class="marginT">
            <el-radio v-model="form.user_limit" label="1">
              所有会员
            </el-radio>
          </div>
          <div class="marginT" style="display: flex; align-items:center">
            <el-radio
              v-model="form.user_limit"
              label="2"
              style="margin-right: 0"
            >
              指定会员
            </el-radio>
            <el-select
              v-model="screenInput"
              placeholder="请选择"
              size="mini"
              multiple
            >
              <el-option
                v-for="item in vipLists"
                :key="item.value"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>可使用用户</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio v-model="form.use_user_limit" label="0">
              所有用户
            </el-radio>
          </div>
          <div class="marginT" style="display: flex; align-items:center">
            <el-radio
              v-model="form.use_user_limit"
              label="1"
              style="margin-right: 0"
            >
              指定会员
            </el-radio>
            <el-select
              v-model="screenInputs"
              placeholder="请选择"
              size="mini"
              multiple
            >
              <el-option
                v-for="item in vipLists"
                :key="item.value"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>可领取门店</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio
              v-model="form.room_limit"
              label="0"
              style="margin-right: 0"
            >
              所有门店
            </el-radio>
          </div>
          <div class="marginT" style="display: flex; align-items:center">
            <el-radio
              v-model="form.room_limit"
              label="1"
              style="margin-right: 0"
            >
              部分门店
            </el-radio>
            <el-select
              v-model="roomId"
              placeholder="请选择"
              size="mini"
              multiple
            >
              <el-option
                v-for="item in storeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name marginT6">
            <span style="color:#606266">优惠券分享</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="">
            <el-row style="margin:0">
              <div class="flex" style="align-items: center">
                <div style="color:#606266" class="newRidio140">
                  优惠券分享标题
                </div>
                <div class="flex">
                  <el-input
                    v-model="form.share_title"
                    placeholder="请输入内容"
                    size="small"
                    class="newRidio160 marginRL"
                  ></el-input>
                  <div class="color marginSX">
                    限15字
                  </div>
                </div>
              </div>
            </el-row>
            <el-row style="margin-top:16px">
              <div class="flex">
                <div class="newRidio140">
                  优惠券分享图
                </div>
                <div class="flex">
                  <el-upload
                    name="image"
                    :data="imgdata"
                    class="avatar-uploader marginRL"
                    :show-file-list="false"
                    accept="image/jpeg,image/gif,image/png"
                    action="https://www.58zltc.com/api/Upload/uploads/"
                    :on-success="handleLogoSuccess"
                    :before-upload="beforeLogoUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>优惠券赠送</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-radio-group v-model="form.is_send">
            <el-radio label="1">可赠送</el-radio>
            <el-radio label="0">不可赠送</el-radio>
          </el-radio-group>
        </el-col>
      </el-row> -->
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>优惠券是否在列表上显示</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-radio-group v-model="form.is_list_show">
            <el-radio label="1">显示</el-radio>
            <el-radio label="0">不显示</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>可用时段</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-radio-group
            v-model="form.is_use_time_status"
            @change="timeStatus = !timeStatus"
          >
            <el-radio label="0">全部时段</el-radio>
            <el-radio label="1">部分时段</el-radio>
          </el-radio-group>
          <div class="marginT" v-if="timeStatus">
            <div class="flex ">
              日期：
              <el-checkbox-group v-model="partTime">
                <el-checkbox label="Monday">周一</el-checkbox>
                <el-checkbox label="Tuesday">周二</el-checkbox>
                <el-checkbox label="Wednesday">周三</el-checkbox>
                <el-checkbox label="Thursday">周四</el-checkbox>
                <el-checkbox label="Friday">周五</el-checkbox>
                <el-checkbox label="Saturday">周六</el-checkbox>
                <el-checkbox label="Sunday">周日</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="flex marginT" style="align-items: center">
              <span>时间：</span>
              <el-time-picker
                class="marginR"
                size="mini"
                is-range
                v-model="dayTime"
                value-format="HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              >
              </el-time-picker>
              <div class="color">不选默认全天</div>
            </div>
          </div>
          <!-- <el-checkbox-group v-model="checkList"> -->

          <!-- </el-checkbox-group> -->
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>库存</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="">
            <el-row style="margin:0">
              <el-col :span="3">
                <div class="flex" style="align-items: center;">
                  <input
                    v-model="form.stock"
                    type="number"
                    :min="0"
                    class="radioInputM"
                    @blur="form.stock = Number(form.stock).toFixed(0)"
                  />
                  <div class="marginR">张</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>领取上限</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="">
            <el-row style="margin:0">
              <el-col :span="10">
                <div class="flex" style="align-items: center;">
                  <input
                    type="number"
                    v-model="form.up_limit"
                    class="radioInputM"
                    :min="0"
                    @blur="form.up_limit = Number(form.up_limit).toFixed(0)"
                  />
                  <div class="marginR">张</div>
                  <div class="color marginRL">
                    商家赠送，营销活动赠送不受此限制
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>限用次数</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="">
            <el-row style="margin:0">
              <el-col :span="10">
                <div class="flex" style="align-items: center;">
                  <input
                    v-model="form.use_limit"
                    class="radioInputM"
                    :min="0"
                    @blur="
                      form.use_limit = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(
                        form.use_limit
                      )
                        ? form.use_limit
                        : '1'
                    "
                    :disabled="form.type == '2'"
                  />
                  <div class="marginR">次</div>
                  <div class="color marginRL"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" name">
            <span>优惠规则说明</span>
            <span style="color:red"></span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="">
            <el-row style="margin:0">
              <el-col :span="10">
                <div class="flex" style="align-items: center;">
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="form.intro"
                    maxlength="200"
                    show-word-limit
                    rows="6"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="bottom">
      <el-button size="small" @click="go">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="submit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import multipleChoice from "@/components/commodity/multipleChoice.vue";
import { mapGetters } from "vuex";
import { addCoupon, editcoupon, detailcoupon } from "@/api/coupon";
import { vipList, goodsList } from "@/api/vip";
import { getCateApi, getComList } from "@/api/mall";
import { storeSelect } from "@/api/employee";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
  },
  components: {
    multipleChoice,
  },
  data() {
    return {
      // 更改选择部分商品的样式
      checkedMalls: [],
      checkedOils: [],
      checkedIntegral: [],
      checkedServe: [],
      // end
      zheStatus: false,
      partTime: [], // 部分时段
      storeList: [], // 店铺列表
      roomId: [], //选中店铺
      mallStatus: false, //部分商品选择
      integralStatus: false, //部分积分商品选择
      oilStatus: false, //部分油品选择
      timeStatus: false, //可用时段
      vipLists: [],
      details_disabled: false,
      jude: 0,
      integral_product: 0, //0 正常商品 1 积分商品
      screenInput: [],
      screenInputs: [],
      classradio: 1,
      checkShowId: 1,
      ticketId: 1,
      conversion: "1", //兑换
      showSelecter: false, //显示商品选择
      // ids: "", //选择的商品id字符串
      sList: [], //已选择的商品列表
      oilPId: "", //油品
      oilPList: [],
      oilPNames: "",
      integralPId: "", //积分商品
      integralPList: [],
      integralPNames: "",
      mallPId: "",
      mallPList: [],
      mallPNames: "", //已选择的商城商品
      fixedTime: [],
      dayTime: ["00:00:00", "00:00:00"],
      getTime: [],
      imgdata: {},
      imageUrl: "",
      imageIdx: 0,
      form: {
        // 新
        condition_type: "0", //使用门槛：0无使用门槛1：满多少元使用
        m_enough_money: "", //订单满钱数
        free_type: "0", //优惠内容0：固定金额1：随机金额
        m_rand_low: "", //随机金额低
        m_rand_high: "", //随机金额高
        zhe_discount: "", //	折扣券：打折数
        zhe_limit: "0", //是否有最多优惠限制0：无1：有
        zhe_limit_money: "", //	最多优惠
        cancle_type: "0", //核销
        change_goods_status: "0", //	可用商品（商品库）0：全部1：部分
        change_goods_ids: "", //
        oli_goods_status: "0", //油品
        oli_goods_ids: "", //
        credit_goods_status: "0", //积分
        credit_goods_ids: "", //
        service_goods_status: "0", //服务
        service_goods_ids: "", //
        use_limit: "1", //使用次数限制
        // old
        title: "",
        sub_title: "",
        type: 1, //  1：满减2：折扣3：代金4：兑换5：储值6：通用7：次数券
        // m_enough_money: "", //满减券：满多少
        m_dec_money: "", //
        d_face_value: "", //
        change_is_exchange: 0, //
        change_is_cost: 0, //
        change_cost: "0", //
        change_is_target_good: 0, //
        change_target_goods_ids: "", //购买指定商品
        chu_face_value: "", //
        use_limit_status: "0", //
        limit_goods_ids: "", //
        t_term: "", //
        c_num: "", //
        get_start_time: "", //
        get_end_time: "", //
        is_term: "0", //
        term_start_time: "", //
        term_end_time: "", //
        term_start_day: "0", //
        term_end_day: "", //
        user_limit: "0", // 领取用户
        limit_user_ids: "", //
        room_limit: "0", //领取门店
        room_ids: "", //门店id
        share_title: "", //
        is_send: "0", //
        send_title: "", //
        share_pic_id: "", //
        // isuse_legal_day_limit: false, //法定节日限制
        // isuse_week_day_limit: false, //周末 废弃
        is_use_time_status: "0", //使用时间段0：全部时间段1：部分时间段
        is_use_time_day: {}, //日期选择（0：关闭1：开启
        intro: "",
        isuse_time_start: "", //
        isuse_time_end: "", //
        stock: "", //
        up_limit: "", //
        address: "", //
        mobile: "", //
        is_list_show: "1",
        copyStatus: false, //新增复制添加优惠券
        use_user_limit: "",
        use_user_level: "",
      },
    };
  },
  mounted() {
    (this.imgdata = {
      app_id: this.app_id,
      token: this.token,
      type: "1",
      file_group: "1",
    }),
      this.getCate();
    if (this.$route.query.idE) {
      if (this.$route.query.copyStatus) {
        //复制重新添加
        this.copyStatus = this.$route.query.copyStatus;
        this.jude = this.$route.query.idE;
        this.getDetail();
      } else {
        //编辑
        this.jude = this.$route.query.idE;
        this.details_disabled = true;
        this.getDetail();
      }
    }
    //
    this.getVipList();
    this.getStore();
  },
  methods: {
    // 多选子组件传递值
    checkedGoods(val, index) {
      if (index == 0) {
        this.form.change_goods_ids = val.join(",");
      } else if (index == 3) {
        this.form.oli_goods_ids = val.join(",");
      } else if (index == 1) {
        this.form.credit_goods_ids = val.join(",");
      } else if (index == 4) {
        this.form.service_goods_ids = val.join(",");
      }
      console.log("多选子组件传递值:", val, index);
    },
    // 請求
    changeProductStatus(index) {
      if (index == 0) {
        this.mallStatus = !this.mallStatus;
      } else if (index == 1) {
        this.integralStatus = !this.integralStatus;
      } else if (index == 3) {
        this.oilStatus = !this.oilStatus;
      }
    },
    // 暂时保留，
    del(type, index) {
      console.log("type", index);
      switch (type) {
        case 0:
          this.mallPList.splice(index, 1);
          break;
        case 1:
          this.integralPList.splice(index, 1);
          break;
        case 3:
          this.oilPList.splice(index, 1);
          break;
      }
    },
    // 会员列表
    getVipList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
      };
      vipList(data).then((res) => {
        console.log("会员列表", res);
        this.vipLists = res.data;
      });
    },
    //
    chengeticket(val) {
      console.log("radio值", val);
      console.log("radio值model", this.classradio);
      this.ticketId = val;
      // 清空值
      this.form.m_enough_money = "";
    },
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.form.share_pic_id = res.data.id;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 获取编辑器内容
    changeeditor(value) {
      console.log("编辑内容", value);
      // this.form.textCon = value;
    },
    go() {
      this.$router.go(-1);
    },
    // 提交
    submit() {
      // 使用門檻
      if (this.form.condition_type == "0" || this.form.condition_type == 0) {
        this.form.m_enough_money = "";
      } else {
        if (this.form.m_enough_money == "") {
          this.$message.warning("请填写使用门槛中的订单金额！！");
          return;
        }
      }
      //代金券
      if (this.form.type == 3 || this.form.type == "3") {
        if (this.form.d_face_value == "") {
          this.$message.warning("请填写固定金额！！");
          return;
        }
      }
      //折扣券
      if (this.form.type == 2) {
        if (this.form.zhe_discount == "") {
          this.$message.warning("请填写打多少折！！");
          return;
        }
      }
      // 满减券的优惠内容
      if (this.form.type == 1) {
        if (this.form.free_type == "0" || this.form.free_type == 0) {
          this.form.m_rand_low = "";
          this.form.m_rand_high = "";
          if (this.form.m_dec_money == "") {
            this.$message.warning("请填写固定金额！！");
            return;
          }
        } else {
          this.form.m_dec_money = "";
          if (this.form.m_rand_low == "" || this.form.m_rand_high == "") {
            this.$message.warning("请填写随机金额！！");
            return;
          }
        }
      }
      // 折扣是否有最高限制
      if (!this.zheStatus) {
        this.form.zhe_limit_money = "";
      } else {
        if (this.form.zhe_limit_money == "") {
          this.$message.warning("请填写优惠内容中的最多优惠多少元！！");
        }
      }
      this.form.zhe_limit = this.zheStatus ? 1 : 0;

      // // 所有部分商品
      // return;
      if (
        this.form.change_goods_status == "1" ||
        this.form.change_goods_status == 1
      ) {
        console.log("bufenyoup", this.form.change_goods_ids);
        if (this.form.change_goods_ids == "") {
          this.$message("请选择对应商城中的部分商品");
          return;
        }
      }
      // 所有部分油品
      if (
        this.form.oli_goods_status == "1" ||
        this.form.oli_goods_status == 1
      ) {
        if (this.form.oli_goods_ids == "") {
          this.$message("请选择对应油品中的部分商品");
          return;
        }
      }
      // 所有部分积分商品
      if (
        this.form.credit_goods_status == "1" ||
        this.form.credit_goods_status == 1
      ) {
        console.log("我走了这一步", this.integralPList);
        console.log("bufenyoup", this.form.credit_goods_ids);
        if (this.form.credit_goods_ids == "") {
          this.$message("请选择对应积分商城中的部分商品");
          return;
        }
      }
      if (this.form.type == 4) {
        switch (this.conversion) {
          case "1":
            this.form.change_is_exchange = 1;
            this.form.change_is_cost = 0;
            this.form.change_is_target_good = 0;
            break;
          case "2":
            this.form.change_is_exchange = 0;
            this.form.change_is_cost = 1;
            this.form.change_is_target_good = 0;
            break;
        }
      }
      if (this.getTime.length == 0) {
        this.$message("请选择领取时间");
        return;
      } else {
        this.form.get_start_time = this.getTime[0];
        this.form.get_end_time = this.getTime[1];
      }

      if (this.form.is_term == "0") {
        if (this.fixedTime.length == 0) {
          this.$message("请填写领取固定时间");
          return;
        } else {
          this.form.term_start_time = this.fixedTime[0];
          this.form.term_end_time = this.fixedTime[1];
          // 去掉可能填写的无关紧要的数据
          this.form.term_start_day = "0";
          this.form.term_end_day = "0";
        }
      } else {
        if (this.form.term_end_day == "0" || this.form.term_end_day == 0) {
          console.log(
            "this.form.term_end_day:",
            this.form.term_end_day,
            "99:",
            this.form.is_term
          );
          this.$message.warning("请填写优惠券领取的有效天数");
          return;
        } else {
          this.fixedTime = [];
        }
      }
      // 可用时段
      this.form.is_use_time_day = {
        Monday: 0,
        Tuesday: 0,
        Wednesday: 0,
        Thursday: 0,
        Friday: 0,
        Saturday: 0,
        Sunday: 0,
      };
      if (this.form.is_use_time_status == "1") {
        if (this.partTime.length > 0) {
          var arr = this.partTime;
          arr.forEach((element) => {
            this.form.is_use_time_day[element] = "1";
          });
          this.form.isuse_time_start = this.dayTime[0];
          this.form.isuse_time_end = this.dayTime[1];
          console.log("可用时段www", this.form.is_use_time_day);
        } else {
          this.$message.warning("请选择勾选部分时段中的时间点");
          return;
        }
      }
      if (this.form.user_limit == "2" && this.screenInput.length == 0) {
        this.$message.warning("请选择指定的会员");
        return;
      } else {
        this.form.limit_user_ids = this.screenInput.join(",");
      }
      if (this.form.use_user_limit == "1" && this.screenInputs.length == 0) {
        this.$message.warning("请选择指定的会员");
        return;
      } else {
        this.form.use_user_level = this.screenInputs.join(",");
      }
      // 店铺id
      if (this.form.room_limit == "1") {
        if (this.roomId.length) {
          this.form.room_ids = this.roomId.join(",");
          console.log("店铺id", this.form.room_ids);
        } else {
          this.$message.warning("请选择部分门店");
          return;
        }
      }
      // 库存，领取限制
      if (this.form.stock == "" || this.form.stock == 0) {
        this.$message.warning("请填写库存！！");
        return;
      }
      if (this.form.up_limit == "" || this.form.up_limit == 0) {
        this.$message.warning("请填写限制领取张数！！");
        return;
      }
      //
      if (this.form.use_limit == "" || this.form.use_limit == 0) {
        this.$message.warning("请填写限用次数！！");
        return;
      }
      let data = Object.assign({}, this.form);
      data.token = this.token;
      data.app_id = this.app_id;
      // 法定节假日
      data.isuse_legal_day_limit =
        this.form.isuse_legal_day_limit == true ? 1 : 0;
      // 周末
      data.isuse_week_day_limit =
        this.form.isuse_week_day_limit == true ? 1 : 0;

      console.log("提交数据", data);

      if (this.jude == 0 || this.copyStatus) {
        if (this.copyStatus) {
          delete data.update_time;
          delete data.create_time;
          delete data.id;
        }
        addCoupon(data).then((res) => {
          console.log("保存优惠券", res);

          if (res.code == 400) {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$router.go(-1);
          }
        });
      } else {
        delete data.update_time;
        delete data.create_time;
        data.id = this.jude;
        editcoupon(data).then((res) => {
          console.log("编辑提交", res);
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
      }
    },
    // 分类
    getCate() {
      let data = {
        token: this.token,
        app_id: this.app_id,
      };
      getCateApi(data).then((res) => {
        console.log("分类数据", res);
        if (res.code == 1) {
          this.catedata = res.data;
        }
      });
    },
    // 分类
    getStore() {
      let data = {
        token: this.token,
        app_id: this.app_id,
      };
      storeSelect(data).then((res) => {
        console.log("门店数据", res);
        if (res.code == 200) {
          this.storeList = res.data;
        }
      });
    },
    // 商品详情
    getDetail() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: this.jude,
      };
      detailcoupon(data).then((res) => {
        if (res.code == 200) {
          this.form = res.data;
          this.imageUrl = res.data.share_pic;
          // 新
          // 折扣是否有最高限制
          this.zheStatus = this.form.zhe_limit ? true : false;
          // 优惠内容
          this.form.free_type = String(this.form.free_type);
          // 使用门槛
          this.form.condition_type = String(this.form.condition_type);
          // 是否有最多优惠限制
          this.form.zhe_limit = String(this.form.zhe_limit);
          this.form.type = Number(this.form.type);
          // 可用商品
          if (this.form.change_goods_status == 1) {
            this.mallStatus = true;
            var arr = this.form.change_goods_ids.split(",");
            arr.forEach((item) => {
              this.checkedMalls.push(item * 1);
            });
            console.log(" this.checkedMalls", this.checkedMalls);
          }
          this.form.change_goods_status = String(this.form.change_goods_status);
          // 油品
          if (this.form.oli_goods_status == 1) {
            this.oilStatus = true;
            var arrs = this.form.oli_goods_ids.split(",");
            arrs.forEach((item) => {
              this.checkedOils.push(item * 1);
            });
            console.log(" this.checkedOils", this.checkedOils);
          }
          this.form.oli_goods_status = String(this.form.oli_goods_status);
          // 积分商品
          if (this.form.credit_goods_status == 1) {
            this.integralStatus = true;
            var arrs = this.form.credit_goods_ids.split(",");
            arrs.forEach((item) => {
              this.checkedIntegral.push(item * 1);
            });
            console.log(" this.checkedIntegral", this.checkedIntegral);
          }
          this.form.credit_goods_status = String(this.form.credit_goods_status);

          // 门店服务
          if (this.form.service_goods_status == 1) {
            this.integralStatus = true;
            var arrs = this.form.service_goods_ids.split(",");
            arrs.forEach((item) => {
              this.checkedServe.push(item * 1);
            });
            console.log(" this.checkedServe", this.checkedServe);
          }
          // 可用服务
          this.form.service_goods_status = String(
            this.form.service_goods_status
          );
          // 可选门店
          if (this.form.room_limit == 1) {
            this.roomId = this.form.room_ids.split(",");
            for (var i in this.roomId) {
              this.roomId[i] = this.roomId[i] * 1;
            }
          }
          this.form.room_limit = String(this.form.room_limit);

          // 可用时段
          if (this.form.is_use_time_status == 1) {
            this.timeStatus = true;
            var arr = this.form.is_use_time_day;
            for (let i in arr) {
              if (arr[i]) {
                this.partTime.push(i);
              }
            }
          }
          this.form.is_use_time_status = String(this.form.is_use_time_status);

          // 核销方式
          this.form.cancle_type = String(this.form.cancle_type);
          // 旧
          //分类
          this.ticketId = this.form.type;
          // 分类下的可用商品
          this.form.use_limit_status = String(this.form.use_limit_status);
          // 兑换选项
          if (this.form.change_is_exchange == 1) {
            this.conversion = "1";
          } else if (this.form.change_is_cost == 1) {
            this.conversion = "2";
          }
          //领取
          this.getTime.push(this.form.get_start_time.split(" ")[0]);
          this.getTime.push(this.form.get_end_time.split(" ")[0]);
          // 有效期
          if (this.form.is_term == 0) {
            this.fixedTime.push(this.form.term_start_time.split(" ")[0]);
            this.fixedTime.push(this.form.term_end_time.split(" ")[0]);
          }

          // 可领取用户
          // // this.form.user_limit = String(this.form.user_limit);
          if (this.form.user_limit == 2) {
            console.log("可领取用户会员id", this.form.limit_user_ids);
            this.screenInput = this.form.limit_user_ids.split(",");
            for (let i in this.screenInput) {
              this.screenInput[i] = this.screenInput[i] * 1;
            }
          }
          if (this.form.use_user_limit == 1) {
            console.log("可使用用户会员id", this.form.use_user_level);
            this.screenInputs = this.form.use_user_level.split(",");
            for (let i in this.screenInputs) {
              this.screenInputs[i] = this.screenInputs[i] * 1;
            }
          }
          this.form.user_limit = String(this.form.user_limit);
          this.form.use_user_limit = String(this.form.use_user_limit);
          // 优惠券赠送
          this.form.is_send = String(this.form.is_send);
          // 有效期
          this.form.is_term = String(this.form.is_term);
          // 是否在列表上显示
          this.form.is_list_show = String(this.form.is_list_show);
          // 法定节假日
          this.form.isuse_legal_day_limit =
            this.form.isuse_legal_day_limit == 1 ? true : false;
          // 周末
          this.form.isuse_week_day_limit =
            this.form.isuse_week_day_limit == 1 ? true : false;
          //
          this.dayTime = [];
          this.dayTime.push(this.form.isuse_time_start);
          this.dayTime.push(this.form.isuse_time_end);
          console.log("form", this.form);
          console.log("form", this.dayTime);
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
        console.log("优惠券详情", res);
      });
    },
    // 整合数据方法
    integerate(array, Plists) {
      let ids = [];
      array.forEach((item) => {
        let shuju = {};
        shuju.id = item.id;
        shuju.name = item.name || item.title;
        shuju.url = item.pic || item.image[0].url;
        Plists.push(shuju);
        ids.push(item.id);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.groups {
  width: 450px;
  padding-bottom: 10px;
}
.el-row {
  font-size: 12px;
  margin-bottom: 30px;
}
.newRidio160 {
  width: 160px;
}
.newRidio140 {
  width: 110px;
}
.el-table td {
  padding: 0px 0;
}
.paddingRight8 {
  padding-right: 8px;
}
.flex {
  display: flex;
  justify-content: flex-start;
}
.color {
  line-height: 28px;
  color: #9fa5bb;
  font-size: 10px;
}

.radioInput {
  height: 26px;
  margin: 0 5px;
  width: 78px;
  border: 1px solid #dcdfe6;
}
.radioInputM {
  height: 28px;
  margin-right: 8px;
  width: 78px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.marginR {
  margin-right: 8px;
}
.marginT {
  margin-top: 10px;
}
.marginT6 {
  margin-top: 6px;
}
.paddingT6 {
  padding-top: 6px;
}
.marginSX {
  margin: 0 5px;
}
.marginTB {
  margin: 10px 0;
}
//
.fixedTitle {
  width: 95px;
  text-align: left;
  padding-right: 15px;
}
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #dcdfe6;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.addNewClass {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .content {
    border-radius: 3px;
    padding: 20px 30px 20px 30px;
    flex: 1;
    overflow-y: scroll;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
    }
    .grid-content {
      // line-height: 36px;
      // min-height: 36px;
      // font-size: 14px;
      .label {
        // width: 70px;
        line-height: 20px;
        // height: 20px;
        padding: 5px 15px;
        border-radius: 20px;
        background: rgba(64, 158, 255, 0.1);
        text-align: center;
        margin-right: 10px;
        position: relative;
        .close {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #ff00004f;
          line-height: 15px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .bottom {
    width: 100%;
    height: 50px;
    background: #fff;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>

<style>
.el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-radio {
  width: 100px;
}
</style>
